export const SETVERSIONS = "SETVERSIONS";
export const SETVALUE1 = "SETVALUE1";
export const SETVALUE2 = "SETVALUE2";
export const COPYPANEL1 = "COPYPANEL1";
export const SYNCPANEL = "SYNCPANEL";
export const SETVALUE = "SETVALUE";
export const ADDVERSIONBOOKS = "ADDVERSIONBOOKS";
export const SETDICTIONARY = "SETDICTIONARY";
